module.exports = __webpack_public_path__ + "img/face-nose-steam.055a3995.svg";